import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

// Function to generate UUID v7
const generateUUID = () => {
  // Get timestamp in milliseconds (48 bits)
  const now = Date.now();
  const timeHex = now.toString(16).padStart(12, '0');
  
  // time_high (32 bits)
  const timeHigh = timeHex.substring(0, 8);
  
  // time_mid (16 bits)
  const timeMid = timeHex.substring(8, 12);
  
  // time_low_and_version (16 bits): 4 bits for version (7) + 12 bits random
  const randomLow = Math.floor(Math.random() * 0x1000).toString(16).padStart(3, '0');
  const timeLowVersion = '7' + randomLow;
  
  // clock_seq_hi_and_reserved and clock_seq_low (16 bits)
  // variant bits (2 bits, set to 10) + 14 bits random
  const variant = (0x8 + Math.floor(Math.random() * 0x3)).toString(16);
  const randomSeq = Math.floor(Math.random() * 0x1000).toString(16).padStart(3, '0');
  const clockSeq = variant + randomSeq;
  
  // node (48 bits, 12 hex chars)
  const node = Math.floor(Math.random() * 0x1000000000000).toString(16).padStart(12, '0');
  
  return `${timeHigh}-${timeMid}-${timeLowVersion}-${clockSeq}-${node}`;
};

// Web Storage wrapper (using localStorage)
const storage = {
  getItem: (key) => {
    try {
      return localStorage.getItem(key);
    } catch (error) {
      //console.error('Error getting item from localStorage:', error);
      return null;
    }
  },
  setItem: (key, value) => {
    try {
      localStorage.setItem(key, value);
    } catch (error) {
      //console.error('Error setting item in localStorage:', error);
    }
  },
  removeItem: (key) => {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      //console.error('Error removing item from localStorage:', error);
    }
  }
};

// Styles
const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'column',
  },
  scrollContainer: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'white',
    padding: '20px',
  },
  outerContainer: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '10px',
  },
  innerContainer: {
    alignItems: 'center',
    backgroundColor: 'white',
    paddingHorizontal: '20px',
    paddingVertical: '25px',
    borderRadius: '20px',
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
    maxWidth: '600px',
    width: '100%',
    margin: '0 auto',
  },
  logo: {
    width: '130px',
    height: '130px',
    display: 'block',
    margin: '0 auto 20px',
    objectFit: 'contain',
  },
  logoGovBr: {
    width: '140px',
    height: '60px',
    objectFit: 'contain',
    marginTop: '5px',
  },
  title: {
    fontSize: '22px',
    fontWeight: '600',
    marginBottom: '8px',
    color: '#137a7f',
    textAlign: 'center',
  },
  subtitle: {
    fontSize: '15px',
    marginBottom: '25px',
    color: '#666',
    textAlign: 'center',
    lineHeight: '20px',
    paddingHorizontal: '10px',
  },
  seletorCidadeContainer: {
    width: '100%',
    marginBottom: '20px',
  },
  seletorCidadeLabel: {
    fontSize: '14px',
    fontWeight: '500',
    color: '#137a7f',
    marginBottom: '8px',
    textAlign: 'center',
  },
  seletorCidadeButton: {
    paddingVertical: '12px',
    paddingHorizontal: '15px',
    borderRadius: '10px',
    backgroundColor: '#f0f7ff',
    borderWidth: '2px',
    borderColor: '#137a7f',
    borderStyle: 'solid',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    cursor: 'pointer',
  },
  seletorCidadeButtonText: {
    fontSize: '14px',
    color: '#137a7f',
    fontWeight: '600',
    textAlign: 'center',
    margin: '10px 0',
    width: '100%',
  },
  seletorCidadeButtonArrow: {
    fontSize: '16px',
    color: '#137a7f',
    position: 'absolute',
    right: '15px',
  },
  cidadeAtualText: {
    fontSize: '12px',
    color: '#666',
    textAlign: 'center',
    marginTop: '5px',
  },
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  modalContent: {
    backgroundColor: 'white',
    borderRadius: '15px',
    padding: '20px',
    width: '80%',
    maxWidth: '400px',
    maxHeight: '60%',
    overflow: 'auto',
  },
  modalTitle: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#137a7f',
    marginBottom: '15px',
    textAlign: 'center',
  },
  cidadeList: {
    maxHeight: '300px',
    overflowY: 'auto',
  },
  cidadeItem: {
    paddingVertical: '12px',
    paddingHorizontal: '15px',
    borderBottomWidth: '1px',
    borderBottomColor: '#eee',
    borderBottomStyle: 'solid',
    cursor: 'pointer',
  },
  cidadeItemSelected: {
    backgroundColor: '#e1f5fe',
  },
  cidadeItemText: {
    fontSize: '14px',
    color: '#333',
  },
  cidadeItemTextSelected: {
    color: '#137a7f',
    fontWeight: '600',
  },
  govBrContainer: {
    alignItems: 'center',
    marginBottom: '15px',
    width: '100%',
  },
  govBrTitle: {
    fontSize: '16px',
    fontWeight: '600',
    color: '#137a7f',
    marginBottom: '12px',
    textAlign: 'center',
  },
  buttonGovBr: {
    width: '100%',
    minWidth: '200px',
    height: '50px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
  },
  buttonVisitante: {
    width: '100%',
    minWidth: '200px',
    height: '50px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#f5f5f5',
    borderRadius: '12px',
    borderWidth: '2px',
    borderColor: '#666',
    borderStyle: 'solid',
    marginTop: '5px',
    cursor: 'pointer',
  },
  buttonDisabled: {
    opacity: 0.5,
    cursor: 'not-allowed',
  },
  buttonText: {
    color: '#137a7f',
    fontSize: '14px',
    fontWeight: '600',
  },
  buttonVisitanteText: {
    color: '#666',
    fontSize: '14px',
    fontWeight: '600',
  },
  infoText: {
    fontSize: '11px',
    color: '#888',
    textAlign: 'center',
    marginTop: '15px',
    paddingHorizontal: '10px',
    lineHeight: '14px',
  },
  modalContainer: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: '#fff',
    zIndex: 2000,
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    backgroundColor: '#0047bb',
    padding: '16px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  headerText: {
    color: 'white',
    fontWeight: 'bold',
    fontSize: '18px',
  },
  iframeContainer: {
    flex: 1,
    position: 'relative',
  },
  iframe: {
    width: '100%',
    height: '100%',
    border: 'none',
  },
  loader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#f5f5f5',
    padding: '40px',
  },
  loadingText: {
    marginTop: '10px',
    fontSize: '16px',
    color: '#666',
  },
  loadingContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
  },
  separator: {
    width: '100%',
    height: '1px',
    backgroundColor: '#e0e0e0',
    marginVertical: '15px',
  },
  spinner: {
    width: '40px',
    height: '40px',
    border: '4px solid #f3f3f3',
    borderTop: '4px solid #137a7f',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
  },
  smallSpinner: {
    width: '20px',
    height: '20px',
    border: '2px solid #f3f3f3',
    borderTop: '2px solid #137a7f',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
  },
  footer: {
    backgroundColor: '#f5f5f5',
    padding: '10px',
    textAlign: 'center',
    borderTopWidth: '1px',
    borderTopColor: '#e0e0e0',
    borderTopStyle: 'solid',
  },
  footerText: {
    fontSize: '12px',
    color: '#666',
    margin: 0,
  },
};

// Add keyframes animation
const styleSheet = document.createElement('style');
styleSheet.textContent = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;
document.head.appendChild(styleSheet);

// Loading Spinner Component
const LoadingSpinner = ({ size = 'small' }) => {
  const spinnerStyle = size === 'small' ? styles.smallSpinner : styles.spinner;
  return <div style={spinnerStyle} />;
};

// Footer Component
const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer style={styles.footer}>
      <p style={styles.footerText}>© {currentYear} - Sistema de Saúde</p>
    </footer>
  );
};

// Modal Component
const Modal = ({ visible, children, onClose }) => {
  if (!visible) return null;

  return (
    <div style={styles.modalOverlay} onClick={onClose}>
      <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        {children}
      </div>
    </div>
  );
};

export default function LoginScreen() {
  const [loadingGovBr, setLoadingGovBr] = useState(false);
  const [loadingVisitante, setLoadingVisitante] = useState(false);
  const [loadingCidades, setLoadingCidades] = useState(true);
  const navigate = useNavigate();

  const [cidadeSelecionada, setCidadeSelecionada] = useState("");
  const [cidades, setCidades] = useState([]);
  const [modalCidadesVisible, setModalCidadesVisible] = useState(false);

  const [cookiesSalvos, setCookiesSalvos] = useState("");

  useEffect(() => {
    carregarCidades();
    carregarCookiesSalvos();
  }, []);

  const carregarCookiesSalvos = async () => {
    try {
      const cookies = storage.getItem('@govbr_cookies');
      if (cookies) {
        setCookiesSalvos(cookies);
        //console.log('✅ Cookies carregados do localStorage');
      }
    } catch (error) {
      //console.error('❌ Erro ao carregar cookies:', error);
    }
  };

  const limparCookies = async () => {
    try {
      storage.removeItem('@govbr_cookies');
      setCookiesSalvos('');
      //console.log('🍪 Cookies limpos');
    } catch (error) {
      //console.error('❌ Erro ao limpar cookies:', error);
    }
  };

  const carregarCidades = async () => {
    try {
      setLoadingCidades(true);
      //console.log('🌐 [carregarCidades] Iniciando carregamento de cidades...');
      const apiUrl = "http://myserverdidatica.servehttp.com:5000/webrun5/apisystems.rule?sys=CTD&chave=066979d925a762cff76230f51fb829fb";
      //console.log('🔗 [carregarCidades] URL da API:', apiUrl);
      
      const response = await fetch(apiUrl);
      //console.log('📥 [carregarCidades] Resposta recebida:');
      //console.log('   - Status:', response.status);
      //console.log('   - Status Text:', response.statusText);

      if (!response.ok) {
        throw new Error(`Erro na requisição: ${response.status}`);
      }

      const data = await response.json();
      //console.log('📊 [carregarCidades] Dados recebidos:', data);

      if (
        data.status === "success" &&
        data.dados &&
        Array.isArray(data.dados)
      ) {
        const cidadesMapeadas = data.dados.map((cidade) => {
          let urlBase = "";
          if (cidade.COD_IBGE === "330225") {
            // urlBase = "http://itatiaia.didaticadigital.com.br:2020/gestao";
            urlBase = "https://itatiaia.didaticadigital.com.br/gestao";
            // urlBase = "http://163.109.72.181:2023/itatiaia/";
          } else if (cidade.COD_IBGE === "330411") {
            urlBase = "https://saudeporto.didaticadigital.com.br/webrunstudio";
          } else {
            urlBase = "https://itatiaia.didaticadigital.com.br/gestao";
          }

          const chaveDaApi = cidade.chave || cidade.CHAVE || cidade.Chave || cidade.CHAVE_SISTEMA || cidade.chaveSistema || cidade.TOKEN || cidade.token;

          return {
            id: cidade.COD_IBGE,
            nome: cidade.CIDADE || cidade.NOME || cidade.nome,
            url: urlBase,
            chave: chaveDaApi ? String(chaveDaApi).trim() : undefined,
          };
        });

        setCidades(cidadesMapeadas);

        if (cidadesMapeadas.length > 0) {
          setCidadeSelecionada(cidadesMapeadas[0].id);
        }
      } else {
        throw new Error("Formato de dados inválido da API");
      }
    } catch (error) {
      //console.error("❌ [carregarCidades] Erro ao carregar cidades:");
      //console.error('   - Mensagem:', error.message);
      //console.error('   - Stack:', error.stack);
      //console.error('   - Erro completo:', error);
      // alert("Não foi possível carregar a lista de cidades. Usando lista padrão.");

      const cidadesFallback = [
        {
          id: "330225",
          nome: "Itatiaia",
          url: "https://itatiaia.didaticadigital.com.br/gestao",
          // urlBase = "http://163.109.72.181:2023/itatiaia";
        },
        {
          id: "330411",
          nome: "Porto Real",
          url: "https://saudeporto.didaticadigital.com.br/webrunstudio",
        },
      ];

      setCidades(cidadesFallback);
      if (cidadesFallback.length > 0) {
        setCidadeSelecionada(cidadesFallback[0].id);
      }
    } finally {
      setLoadingCidades(false);
    }
  };

  const handleLoginVisitante = async () => {
    try {
      if (!cidadeSelecionada) {
        alert("Por favor, selecione uma cidade");
        return;
      }

      setLoadingVisitante(true);

      const cidade = cidades.find(c => c.id === cidadeSelecionada);
      if (!cidade) {
        alert("Cidade não encontrada");
        return;
      }

      const baseUrl = cidade.url;

      storage.setItem("link", baseUrl);
      storage.setItem("storageLink", baseUrl);
      storage.setItem("chave", "066979d925a762cff76230f51fb829fb");
      storage.setItem("modoVisitante", "true");
      storage.setItem("cidadeSelecionada", cidade.id);
      storage.setItem("nomeCidade", cidade.nome);

      // //console.log("🔄 Buscando dados da API como visitante...");
      // const resultadoApi = await buscarDadosDaAPI(cpfVisitante, baseUrl);

      // if (resultadoApi.success) {
      //   //console.log("✅ Dados da API obtidos com sucesso para visitante");
      //   // Navegar para o menu
      //   router.navigate("/menu");
      // } else {
      //   //console.warn("⚠️ Não foi possível obter dados da API como visitante:", resultadoApi.error);
      // Mesmo sem dados da API, navegar para o menu
      // Alert.alert(
      //   "Aviso",
      //   "Login como visitante realizado. Algumas funcionalidades podem estar limitadas.",
      //   [
      //     {
      //       text: "OK",
      //       onPress: () => 
      localStorage.setItem('autenticado', 'true');
      navigate('/Menu');
      //     }
      //   ]
      // );
      // }
      // } catch (error) {
      //   //console.error("❌ Erro no login como visitante:", error);
      // Alert.alert("Erro", "Não foi possível realizar o login como visitante");
    } finally {
      setLoadingVisitante(false);
    }
  };

async function handleGovbrLogin() {
    //console.log('handleGovbrLogin chamado');
    try {
      setLoadingGovBr(true);
      //console.log('Iniciando login GOV.BR para cidade:', cidadeSelecionada);

      // Gerar UUID
      const guid = generateUUID();
      //console.log('GUID gerado:', guid);

      // Salvar cidade selecionada e links no storage
      storage.setItem("cidadeSelecionada", cidadeSelecionada);
      const cidade = cidades.find(c => c.id === cidadeSelecionada);
      if (cidade) {
        storage.setItem("urlbase", cidade.url);
        storage.setItem("link", cidade.url);
        storage.setItem("storageLink", cidade.url);
        const chaveSelecionada = cidade.chave || cidade.CHAVE || storage.getItem('chave') || '066979d925a762cff76230f51fb829fb';
        storage.setItem('chave', chaveSelecionada);
        //console.log('💾 [handleGovbrLogin] Storage atualizado: link, storageLink, chave');
      }

      // Construir wsInicializar com GUID no redirect
      const wsInicializar = `https://loginunico.portoreal.rj.gov.br/loginunico/WSAuthInit.rule?sys=SLU&redirect=https://saudenapalmadamao.didaticadigital.com.br/govbr-callback?GUID=${guid}`;
      //console.log('🔗 [handleGovbrLogin] URL da API GOV.BR:', wsInicializar);

      // Chama API para obter o token temporário
      //console.log('🌐 [handleGovbrLogin] Fazendo requisição para API GOV.BR...');
      const response = await axios.get(wsInicializar);
      //console.log('📥 [handleGovbrLogin] Resposta da API GOV.BR (wsInicializar) recebida:');
      //console.log('   - Status:', response.status);
      //console.log('   - Headers:', response.headers);
      //console.log('   - Dados completos:', response.data);
      //console.log('   - Location:', response.data?.location);
      //console.log('   - Token:', response.data?.token);

      if (response.status !== 200) {
        setLoadingGovBr(false);
        throw new Error("Erro ao obter token");
      }

      if (!response.data?.location || !response.data?.token) {
        setLoadingGovBr(false);
        throw new Error("Erro ao obter location ou token");
      }

      const token = response.data.token;
      //console.log('🔑 [handleGovbrLogin] Token obtido:', token);

      // Primeiro: Chamar apiloginmobile com GUID e token para armazenar no servidor
      const urlbase = cidade.url;
      const chave = storage.getItem('chave') || '066979d925a762cff76230f51fb829fb';
      const loginUrl = `${urlbase}/apiloginmobile.rule?sys=SAU&chave=${chave}&GUID=${guid}&token=${token}`;
      //console.log('   - Chave usada:', chave);
      //console.log('🔗 [handleGovbrLogin] URL de login móvel construída:');
      //console.log('   - URL:', loginUrl);
      //console.log('   - Parâmetros: GUID e token');

      //console.log('🌐 [handleGovbrLogin] Fazendo requisição para API de login móvel (armazenamento)...');
      const loginResponse = await axios.get(loginUrl);
      //console.log('📥 [handleGovbrLogin] Resposta da API de login móvel (apiloginmobile) recebida:');
      //console.log('   - Status:', loginResponse.status);
      //console.log('   - Headers:', loginResponse.headers);
      //console.log('   - Dados completos:', loginResponse.data);
      //console.log('   - Tipo de dados:', typeof loginResponse.data);

      if (loginResponse.status === 200) {
        //console.log('✅ [handleGovbrLogin] Token armazenado com sucesso no servidor via apiloginmobile');
        
        // Armazenar GUID localmente após login bem-sucedido
        localStorage.setItem('govbr_guid', guid);
        //console.log('💾 [handleGovbrLogin] GUID armazenado localmente:', guid);

        // Segundo: Abrir o link de autenticação GOV.BR
        //console.log('🔗 [handleGovbrLogin] Abrindo link de autenticação GOV.BR...');
        //console.log('   - Location:', response.data.location);
        window.location.href = response.data.location;
      } else {
        throw new Error('Erro ao armazenar token no servidor');
      }
    } catch (error) {
      //console.error("❌ [handleGovbrLogin] Erro ao obter token:");
      if (error.response) {
        //console.error('   - Status:', error.response.status);
        //console.error('   - Status Text:', error.response.statusText);
        //console.error('   - Headers:', error.response.headers);
        //console.error('   - Dados do erro:', error.response.data);
        //console.error('   - Config:', error.config);
      } else if (error.request) {
        //console.error('   - Nenhuma resposta recebida');
        //console.error('   - Request:', error.request);
      } else {
        //console.error('   - Mensagem:', error.message);
        //console.error('   - Stack:', error.stack);
      }
      alert("Erro: Não foi possível iniciar o login GOV.BR");
      setLoadingGovBr(false);
    }
  };

  const selecionarCidade = (id) => {
    setCidadeSelecionada(id);
    setModalCidadesVisible(false);
  };

  const cidadeAtual = cidades.find(c => c.id === cidadeSelecionada);

  return (
    <div style={styles.container}>
      <div style={styles.scrollContainer}>
        <div style={styles.outerContainer}>
          <div style={styles.innerContainer}>
            <img
              src={require("./assets/logoSPM.png")}
              alt="Logo"
              style={styles.logo}
            // onError={(e) => {
            //   e.target.onerror = null;
            //   e.target.src = "https://via.placeholder.com/130x130?text=Logo";
            // }}
            />
            <h1 style={styles.title}>Saúde na palma da mão!</h1>
            <p style={styles.subtitle}>
              Acesse seus dados de saúde de forma segura
            </p>

            <div style={styles.govBrContainer}>
              <p style={styles.govBrTitle}>Acessar com</p>
              <div
                style={{
                  ...styles.buttonGovBr,
                  ...((loadingGovBr || loadingVisitante) ? styles.buttonDisabled : {})
                }}
                onClick={handleGovbrLogin}
              >
                <img
                  src={require("./assets/govbr_logo.png")}
                  alt="Gov.br"
                  style={styles.logoGovBr}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "https://via.placeholder.com/140x60?text=Gov.br";
                  }}
                />
                {loadingGovBr && <span style={styles.buttonText}>Carregando...</span>}
              </div>
            </div>

            <div style={styles.separator} />

            <div style={styles.seletorCidadeContainer}>
              <p style={styles.seletorCidadeLabel}>Ou selecione sua cidade para entrar como visitante:</p>

              {loadingCidades ? (
                <div style={styles.loadingContainer}>
                  <LoadingSpinner size="small" />
                  <p style={{ color: '#666', marginTop: '5px' }}>Carregando cidades...</p>
                </div>
              ) : (
                <>
                  <div
                    style={styles.seletorCidadeButton}
                    onClick={() => setModalCidadesVisible(true)}
                  >
                    <span style={styles.seletorCidadeButtonText}>
                      {cidadeAtual ? cidadeAtual.nome : "Selecione uma cidade"}
                    </span>
                    <span style={styles.seletorCidadeButtonArrow}>▼</span>
                  </div>

                  {cidadeAtual && (
                    <p style={styles.cidadeAtualText}>
                      Cidade selecionada: {cidadeAtual.nome}
                    </p>
                  )}
                </>
              )}
            </div>

            <div
              style={{
                ...styles.buttonVisitante,
                ...((loadingGovBr || loadingVisitante || !cidadeSelecionada) ? styles.buttonDisabled : {})
              }}
              onClick={handleLoginVisitante}
            >
              {loadingVisitante ? (
                <LoadingSpinner size="small" />
              ) : (
                <span style={styles.buttonVisitanteText}>
                  Entrar como Visitante
                </span>
              )}
            </div>

            <p style={styles.infoText}>
              *Modo visitante: Acesso limitado à algumas funcionalidades básicas.
            </p>
          </div>

          <Modal visible={modalCidadesVisible} onClose={() => setModalCidadesVisible(false)}>
            <h3 style={styles.modalTitle}>Selecione sua cidade</h3>
            <div style={styles.cidadeList}>
              {cidades.map((cidade) => (
                <div
                  key={cidade.id}
                  style={{
                    ...styles.cidadeItem,
                    ...(cidadeSelecionada === cidade.id ? styles.cidadeItemSelected : {})
                  }}
                  onClick={() => selecionarCidade(cidade.id)}
                >
                  <span style={{
                    ...styles.cidadeItemText,
                    ...(cidadeSelecionada === cidade.id ? styles.cidadeItemTextSelected : {})
                  }}>
                    {cidade.nome}
                  </span>
                </div>
              ))}
            </div>
          </Modal>
        </div>
      </div>

      <Footer />
    </div>
  );
}